<div>
  <span>
    <span class="screen-reader-only">{{ getAriaLabelValue() }}</span>
    @if (step()) {
      <span class="tracker-step" aria-hidden="true"
        [ngClass]="{'completed': step()!.ChevronStatus === 'Completed', 'inprogress': step()!.ChevronStatus === 'Pending', 'alert': step()!.ChevronStatus === 'Alert'}">
      <i [ngClass]="{ fas: step()!.ChevronStatus === 'Completed' || step()!.ChevronStatus === 'Alert',
                      far: step()!.ChevronStatus === 'Pending' || step()!.TrackerChevron === 'Not in good order',
                      'fa-check': step()!.ChevronStatus === 'Completed',
                      'fa-times-circle': step()!.TrackerChevron === 'Not in good order',
                      'fa-ban': step()!.ChevronStatus === 'Alert',
                      'fa-clock': step()!.ChevronStatus === 'Pending'}"></i>
        {{ truncateText() }} &nbsp;
        @if (step()!.StatusDate !== '') {
          <span class="mobile-view">| &nbsp;
            <span class="screen-reader-only">status date, </span>
            {{ step()!.StatusDate | customDate:'MM/DD/YYYY' }}
          </span>
        }
      </span>
    }
  </span>

  @if (step()) {
    <span class="status-date">
      @if (step()!.StatusDate !== '') {
        <span class="no-mobile-view">
          <span class="screen-reader-only">status date, </span>
          {{ step()!.StatusDate | customDate:'MM/DD/YYYY' }}
        </span>
      }
      <span>
        @if (step()!.TrackerChevron === trackerChevron.Licensing && step()!.ChevronStatus !== 'Completed') {
          <span class="screen-reader-only" aria-live="polite">
            on view link click page will scroll to outstanding requirements section
          </span>
        }
        @if (step()!.TrackerChevron === trackerChevron.Licensing && step()!.ChevronStatus !== 'Completed') {
          <a href="javaScript:void(0)" (click)="scrollTo('outstanding-requirements', step()!.TrackerChevron)">
            View
          </a>
        }
      </span>
      @if (SourceOfFundsUI()?.length) {
        @if (step()!.TrackerChevron.indexOf(trackerChevron.TransferInitiated) > -1 || step()!.TrackerChevron === trackerChevron.FundsReceived || step()!.TrackerChevron === trackerChevron.ContractIssued) {
          <span
            class="screen-reader-only" aria-live="polite">
            on view link click page will scroll to source of fund section
          </span>
        }
        @if (step()!.TrackerChevron.indexOf(trackerChevron.TransferInitiated) > -1 && notNoLOA() || step()!.TrackerChevron === trackerChevron.FundsReceived && notNoLOA() || step()!.TrackerChevron === trackerChevron.ContractIssued) {
          <a href="javaScript:void(0)"
            (click)="scrollTo('source-of-fund', step()!.TrackerChevron)">
            View
          </a>
        }
      }
      @if (FundsReceivedMoneyIn()?.length && !SourceOfFundsUI()?.length) {
        @if (step()!.TrackerChevron === trackerChevron.FundsReceived && notNoLOA() || step()!.TrackerChevron === trackerChevron.ContractIssued) {
          <span
            class="screen-reader-only" aria-live="polite">
            on view link click page will scroll to funds received section
          </span>
        }
        @if (step()!.TrackerChevron === trackerChevron.FundsReceived && notNoLOA() || step()!.TrackerChevron === trackerChevron.ContractIssued) {
          <a href="javaScript:void(0)"
            (click)="scrollTo('funds-received', step()!.TrackerChevron)">
            View
          </a>
        }
      }
    </span>
  }
</div>
